import React, { useState } from "react";
import Todos from "./Todos";
import style from "./home.module.css";
import NewTodo from "./NewTodo";
import { v4 as uuidv4 } from "uuid";
const Home = () => {
  const [todos, setTodo] = useState([]);
  const handleAddTodo = (todoInner) => {
    setTodo((prevTodo) => {
      return [...prevTodo, { id: uuidv4(), todoInner }];
    });
  };
  const handleRemoval = (id) => {
    setTodo((prevTodos) => {
      const filteredTodo = prevTodos.filter((todo) => todo.id != id);
      return filteredTodo;
    });
  };
  return (
    <div className={style.container}>
      <h1 style={{ color: "white" }}>Todo App</h1>
      <NewTodo addTodo={handleAddTodo} />
      <Todos todos={todos} onRemoveTodo={handleRemoval} />
    </div>
  );
};

export default Home;
